import {Directive, EventEmitter, HostListener, Output} from "@angular/core";

enum TouchType {
    NONE,
    SHORT,
    LONG
}

/**
 * Directive to detect short vs long press/touch
 */
@Directive({selector: '[fui-touch]'})
export class FUITouchDirective {

    @Output()
    shortTouch = new EventEmitter();
    @Output()
    longTouch = new EventEmitter();

    private timeout: ReturnType<typeof setTimeout>;
    private touchType: TouchType;

    @HostListener("touchstart", ["$event"]) @HostListener('mousedown', ["$event"]) onMouseDown(event: Event): void {
        this.touchType = TouchType.SHORT;
        this.timeout = setTimeout(() => {
            this.touchType = TouchType.LONG;
        }, 500);
        event.stopPropagation();
    }

    @HostListener("touchend", ["$event"]) @HostListener('mouseup', ["$event"]) onMouseUp(event: Event): void {
        if (this.touchType === TouchType.SHORT) {
            this.shortTouch.emit(event);
        } else if (this.touchType === TouchType.LONG) {
            this.longTouch.emit(event);
        }
        this.touchType = TouchType.NONE;
        clearTimeout(this.timeout);
        event.stopPropagation();
        event.preventDefault();
    }

    @HostListener("touchcancel", ["$event"]) @HostListener('mouseleave', ["$event"]) onMouseLeave(event: Event): void {
        this.touchType = TouchType.NONE;
        clearTimeout(this.timeout);
    }

    @HostListener("touchmove", ["$event"]) onTouchMove(event: TouchEvent): void {
        this.touchType = TouchType.NONE;
        clearTimeout(this.timeout);
    }

    @HostListener('mousemove', ["$event"]) onMouseMove(event: MouseEvent): void {
        if (event.movementX !== 0 && event.movementY !== 0) {
            this.touchType = TouchType.NONE;
            clearTimeout(this.timeout);
        }
    }

    @HostListener("click", ["$event"]) onClick(event: Event): void {
        event.stopPropagation();
    }

    @HostListener("contextmenu", ["$event"]) onContextMenu(event: Event): void {
        event.stopPropagation();
        event.preventDefault();
    }
}
